import Dialog from "@Features/dialog/components/Dialog";
import React, {MutableRefObject} from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";

interface AmenityErrorModalProps {
    errorDialogRef: MutableRefObject<HTMLDialogElement>
}

function AmenityErrorModal({errorDialogRef}: AmenityErrorModalProps) {
    const {
        title: titleLabel,
        cta: ctaLabel,
    } = useTranslation("check_order.amenities.error")

    const refreshResultsButtonLabel = useTranslation("search_results.refresh_results_button")

    return (
        <Dialog dialogRef={errorDialogRef}>
            <h5 className="modal-title gb-modal-title">
                {titleLabel}
            </h5>
            <div className="modal-body gb-modal-body">
                {ctaLabel}
            </div>
            <div className="gb-modal-footer--actions">
                <button
                    type="button"
                    onClick={() => {
                        window.location.reload()
                    }}
                    className="btn btn--green"
                >
                    {refreshResultsButtonLabel}
                </button>
            </div>
        </Dialog>
    )
}

export default AmenityErrorModal